import React from "react";
import { Navigate } from "react-router-dom";
import { useSnackbar } from "../../../shared/components/layout/SnackbarContext";
import AuthPage from "../../../shared/components/ui/AuthPage";
import { SimpleAuthenticationServiceContext } from "../../../shared/services/api/contexts";

export default function SignInPage() {
  const { showSnackbar } = useSnackbar();
  const authenticationService = React.useContext(SimpleAuthenticationServiceContext);

  const [loading, setLoading] = React.useState<boolean>(false);
  const [errors, setErrors] = React.useState<{ email?: string; password?: string }>({});

  const onSubmit = async (email: string, password: string) => {
    // Clear previous errors
    setErrors({});

    // Basic validation
    const newErrors: { email?: string; password?: string } = {};
    if (!email) {
      newErrors.email = "Email is required";
    }
    if (!password) {
      newErrors.password = "Password is required"; // NOSONAR - This is an error message, not a credential
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);
    try {
      await authenticationService.login(email, password);
    } catch (e: any) {
      showSnackbar({ text: e.message, color: "danger" });
      return;
    } finally {
      setLoading(false);
    }
  };

  if (authenticationService.isAuthenticated()) {
    return <Navigate to="/" />;
  }

  return <AuthPage loading={loading} onSubmit={onSubmit} errors={errors} />;
}
